module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-08.e3d059e6.png";